import './VHorizontalTable.css';
import React from 'react';

class VHorizontalTable extends React.Component {
    priceScale = 2;
    quantityScale = 1;
    power = 'Power:';
    price = 'Price:';
    totalPower = 'Total P:';
    offerInterval = 'Offer Interval';
    pair = 'Pair';

    render() {
        let maxOrder = 9;

        this.props.data.forEach(h => {
            h.offers.forEach(o => {
                if (o.order > maxOrder)
                    maxOrder = o.order;
            })
        });

        const hourTotals = {};
        this.props.data.forEach(d => {
            const totalQuantity = d.offers.reduce((total, current) => current.quantity + total, 0);
            hourTotals[d.hour] = totalQuantity;
        })

        const horizontalTableList = [];
        const hours = Object.keys(hourTotals);
        for (const hour of hours) {
            const hourInt = parseInt(hour);
            const rowData = this.props.data.find(hourData => hourData.hour === hourInt);

            const temp = <>
                <div style={{ display: 'grid', backgroundColor: 'white', gridTemplateColumns: `3fr repeat(${maxOrder + 1}, 1fr)`, gridTemplateRows: '2fr' }}>
                    <div style={{ display: 'grid', backgroundColor: 'rebeccapurple', gridTemplateColumns: '1fr 1fr 1fr', gridTemplateRows: '1fr', border: '1px solid black' }}>
                        <div style={{ display: 'grid', backgroundColor: '#fbe5d6', borderRight: '1px solid black' }}>
                            <div style={{ display: 'grid', textAlign: 'center' }}>
                                {`${parseInt(hour) + 1}`}
                            </div>
                            <div style={{ display: 'grid' }}>
                                {''}
                            </div>
                        </div>
                        <div style={{ display: 'grid', backgroundColor: '#f2f2f2', borderRight: '1px solid black' }}>
                            <div style={{ display: 'grid', borderBottom: '1px solid black', textAlign: 'center' }}>
                                {`${this.totalPower}`}
                            </div>
                            <div style={{ display: 'grid', textAlign: 'center' }}>
                                {hourTotals[hour]}
                            </div>
                        </div>
                        <div style={{ display: 'grid', borderRight: '1px solid black', textAlign: 'center' }}>
                            <div style={{ display: 'grid', backgroundColor: '#f2f2f2', borderBottom: '1px solid black' }}>
                                {`${this.power}`}
                            </div>
                            <div style={{ display: 'grid', backgroundColor: '#deebf7' }}>
                                {`${this.price}`}
                            </div>
                        </div>
                    </div>
                    {
                        [...Array(maxOrder + 1).keys()].map(order => {
                            const orderData = rowData.offers.find(offerData => offerData.order === (order + 1));
                            let quantity = '', price = '';

                            if (orderData) {
                                const quantity = Number(orderData.quantity);
                                const price = Number(orderData.price);

                                return (
                                    <div style={{ border: '1px solid black' }}>
                                        <div style={{ backgroundColor: '#ffffff', textAlign: 'center', height: '50%', width: '100%', borderBottom: '1px solid black' }}>{quantity.toFixed(this.quantityScale)}</div>
                                        <div style={{ backgroundColor: '#deebf7', textAlign: 'center', height: '50%', width: '100%' }}>{price.toFixed(this.priceScale)}</div>
                                    </div>
                                )

                            }

                            return (
                                <div style={{ border: '1px solid black' }}>
                                    <div style={{ backgroundColor: '#ffffff', textAlign: 'center', height: '50%', width: '100%', borderBottom: '1px solid black' }}>{quantity}</div>
                                    <div style={{ backgroundColor: '#deebf7', textAlign: 'center', height: '50%', width: '100%' }}>{price}</div>
                                </div>
                            )
                        })
                    }
                </div>
            </>
            horizontalTableList.push(temp);
        }

        return (
            <div style={{ minWidth: '2000px', overflow: 'visible' }}>
                <div style={{ display: 'grid', overflow: 'visible', gridTemplateRows: `repeat(${maxOrder + 1}, 1fr)` }}>
                    <div style={{ backgroundColor: 'white', display: 'grid', gridTemplateColumns: `3fr repeat(${maxOrder + 1}, 1fr)`, gridTemplateRows: '1fr', borderBottom: '2px solid black' }}>
                        <div style={{ border: '1px solid black', backgroundColor: '#fbe5d6', textAlign: 'center', fontSize: '16px', alignContent: 'center' }}>{`${this.offerInterval}`}</div>
                        {[...Array(maxOrder + 1).keys()].map((order) =>
                            <div style={{ textAlign: 'center', border: '1px solid black', backgroundColor: '#fbe5d6', alignContent: 'center' }}>{`${this.pair} ${order + 1}`}</div>)
                        }
                    </div>
                    {horizontalTableList}
                </div>
            </div>
        );
    }
}

VHorizontalTable.defaultProps = {
    data: []
}

export default VHorizontalTable;